import React, { Suspense } from 'react';
import { IMatchChangeLmpTemplate } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchChangeLmpWrapper = React.lazy(() => import('./match-change-lmp'));

export interface IDynamicMatchChangeLmpWrapper extends IComponentModel<IMatchChangeLmpTemplate> {
  live?: boolean;
  model: any;
}

const DynamicMatchChangeLmp = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicMatchChangeLmpWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchChangeLmpWrapper
      live={live}
      initialModel={validateModel(model) as IMatchChangeLmpTemplate}
      query={validateModel(query)}
    />
  </Suspense>
);

DynamicMatchChangeLmp.defaultProps = {
  live: false,
};

export default DynamicMatchChangeLmp;
